<script>
export default {
	name: 'cookie-renew',
	methods: {
		renew() {
			window.CookieConsent.renew();
		},
	},
};
</script>

<template src="./cookie-renew.html"></template>
<style src="./cookie-renew.scss"></style>


// WEBPACK FOOTER //
// cookie-renew.vue?b2a881ac